import type { DecorationScreenSchema } from "./types";

export const loyaltyAuthSchema = {
	back_button: { css: [], variant: { values: ["arrow", "icon"], default: "arrow" }, icon: true },
	body: { css: [] },
	card: { css: [] },
	close_button: { css: [], variant: { values: ["cross", "icon"], default: "cross" }, icon: true },
	code_field: { css: [] },
	confirm_button: { css: ["active"] },
	confirm_wrapper: { css: [] },
	field: { css: [] },
	header: { css: [] },
	key: { css: ["action"] },
	key_backspace_icon: { css: [] },
	key_clear: { variant: { values: ["text", "icon"], default: "text" }, icon: true },
	keypad: { css: [] },
	overlay: { css: [] },
	phone_field: { css: [], variant: { values: ["plain", "pill"], default: "plain" } },
	step: { css: [] },
	subtitle: { css: [] },
	title: { css: [] },
} as const satisfies DecorationScreenSchema;
